<template>
  <div>
    <h1 class="te-law-page-title co-display-8 mb-16 mt-5 text-center leading-none md:mb-20">
      特定商取引法に関する表示
    </h1>
    <div class="w-full leading-loose">
      <div class="border-b border-co-gray-200 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 basis-full text-center font-bold lg:mb-0 lg:basis-1/3 lg:px-4 lg:font-normal">
          会社名
        </div>
        <div class="basis-full text-center lg:basis-2/3 lg:px-4 lg:text-left">
          株式会社ブリューアス
        </div>
      </div>
      <div class="border-b border-co-gray-200 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 basis-full text-center font-bold lg:mb-0 lg:basis-1/3 lg:px-4 lg:font-normal">
          代表者
        </div>
        <div class="basis-full text-center lg:basis-2/3 lg:px-4 lg:text-left">
          代表取締役社長 安川 昌平
        </div>
      </div>
      <div class="border-b border-co-gray-200 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 basis-full text-center font-bold lg:mb-0 lg:basis-1/3 lg:px-4 lg:font-normal">
          所在地
        </div>
        <div class="basis-full text-center lg:basis-2/3 lg:px-4 lg:text-left">
          東京都渋谷区渋谷一丁目2番5号
        </div>
      </div>
      <div class="border-b border-co-gray-200 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 basis-full text-center font-bold lg:mb-0 lg:basis-1/3 lg:px-4 lg:font-normal">
          問い合わせ先
        </div>
        <div class="basis-full text-center lg:basis-2/3 lg:px-4 lg:text-left">
          <a href="mailto:support@techacademy.jp">support@techacademy.jp</a>
        </div>
      </div>
      <div class="border-b border-co-gray-200 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 basis-full text-center font-bold lg:mb-0 lg:basis-1/3 lg:px-4 lg:font-normal">
          電話番号
        </div>
        <div class="basis-full text-center lg:basis-2/3 lg:px-4 lg:text-left">
          上記記載のメールアドレスへご連絡いただければ、速やかに電話番号をご案内いたします。
        </div>
      </div>
      <div class="border-b border-co-gray-200 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 basis-full text-center font-bold lg:mb-0 lg:basis-1/3 lg:px-4 lg:font-normal">
          お支払い方法
        </div>
        <div class="basis-full text-center lg:basis-2/3 lg:px-4 lg:text-left">
          指定口座への銀行振込、クレジットカード決済、コンビニ決済、Amazon Pay、PayPay
        </div>
      </div>
      <div class="border-b border-co-gray-200 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 basis-full text-center font-bold lg:mb-0 lg:basis-1/3 lg:px-4 lg:font-normal">
          販売価格
        </div>
        <div class="basis-full text-center lg:basis-2/3 lg:px-4 lg:text-left">
          各コース詳細ページに表示された価格に基づきます。
        </div>
      </div>
      <div class="border-b border-co-gray-200 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 basis-full text-center font-bold lg:mb-0 lg:basis-1/3 lg:px-4 lg:font-normal">
          お支払い期限
        </div>
        <div class="basis-full text-center lg:basis-2/3 lg:px-4 lg:text-left">
          利用規約に記載のとおりです。
        </div>
      </div>
      <div class="border-b border-co-gray-200 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 basis-full text-center font-bold lg:mb-0 lg:basis-1/3 lg:px-4 lg:font-normal">
          コース代金以外の料金
        </div>
        <div class="basis-full text-center lg:basis-2/3 lg:px-4 lg:text-left">
          コース代金以外に料金がかかる場合は、コース詳細ページに別途記載いたします。なおサービスの提供を受けるために必要な、コンピューター、スマートフォン、マイクやウェブカメラ、通信回線その他の通信環境等は、お客様の費用と責任において準備し維持するものとします。
        </div>
      </div>
      <div class="border-b border-co-gray-200 py-4 sm:mx-2 lg:flex">
        <div class="mb-2 basis-full text-center font-bold lg:mb-0 lg:basis-1/3 lg:px-4 lg:font-normal">
          キャンセル等その他の事項
        </div>
        <div class="basis-full text-center lg:basis-2/3 lg:px-4 lg:text-left">
          ＜クーリング・オフについて＞<br>本サービスはクーリング・オフ適用対象外です。<br><br>＜サービス提供開始前のキャンセルについて＞<br>キャンセル可能です。受講開始にかかわらず、学習システム（カリキュラム）にログインされた後のご返金・コース変更はいたしかねますのでご了承下さい。<br>なおログイン実施前かつ、受講開始日の1営業日前までであれば、振込手数料を引いて全額返金いたします。（受付：平日10時〜18時）<br><br>＜サービス提供開始後のキャンセルについて＞<br>サービスの性質上、サービス提供開始後のお客様都合によるキャンセルはお受けしておりません。<br><br>＜サービス提供時期について＞<br>コース開始の初日。
        </div>
      </div>
      <div class="mx-2 py-4 lg:flex">
        <div class="mb-2 basis-full text-center font-bold lg:mb-0 lg:basis-1/3 lg:px-4 lg:font-normal">
          個人情報のお取り扱い
        </div>
        <div class="basis-full text-center lg:basis-2/3 lg:px-4 lg:text-left">
          取り扱いの詳細については、
          <a
            href="/privacypolicy"
            target="_blank"
          >プライバシーポリシー</a>をご参照下さい。
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { scriptTagsByConfig } from '~/utility/scriptTags'
import { metaTags } from '~/utility/constants/metaTags'

const options = {
  async setup() {
    definePageMeta({
      layout: 'te-side-menu'
    })
  },
  oldHead() {
    const scriptTags = scriptTagsByConfig({
      useCase: 'index',
    })
    return {
      title: '特定商取引法に関する表示|テックアカデミー',
      meta: [
        ...metaTags(
          {
            description:
            'TechAcademyの特定商取引に関する表示です。 ',
            ogUrl: '/law',
            noIndexNofollow: true,
          },
          process.env.host as string
        ),
      ],
      script: scriptTags!.script,
      noscript: scriptTags!.noscript,
    }
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-law-page-title {
  @media (min-width: 768px) {
    font-size: 2rem;
  }
}
</style>
